// extracted by mini-css-extract-plugin
export default {"person":"styles_person__qRHCt","photo":"styles_photo__h-lJw","description":"styles_description__8tDvW","fio":"styles_fio__jB5Xz","item":"styles_item__INhbZ"};